module.exports = __webpack_public_path__ + "img/arrowhead.b2e36de6.png";